<template>
    <header class="zs-canvas-topbar">
        <div class="zs-canvas-topbar__inner">
            <button type="button" class="zs-mobilenav-toggle" aria-label="Open navigation" @click="mobileNav.toggle()">
                <i class="fa-solid fa-bars" />
            </button>
            <div class="zs-canvas-topbar__main">
                <slot>
                    <span class="zs-crumb">
                        <span>{{ store.rootAppName ?? '' }}</span>
                        <span v-if="terminalLabel" class="zs-crumb__sep">/</span>
                        <b v-if="terminalLabel">{{ terminalLabel }}</b>
                    </span>
                </slot>
            </div>
            <div class="zs-canvas-topbar__actions">
                <slot name="actions" />
            </div>
        </div>
    </header>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import { useMobileNav } from '@/shared/helpers/mobile-nav';
import { useStore } from '@/store';

const store = useStore();
const mobileNav = useMobileNav();

// Only show a sub-app segment when one is explicitly set (via route meta or
// useSubAppName). Don't fall back to the raw route name — it's a slug like
// "rmm" / "rmm-endpoint-tab", not a user-facing label.
const terminalLabel = computed(() => store.subAppName ?? null);
</script>
